import React, { useRef } from 'react';
import { Layout } from 'antd';
import styled from 'styled-components';

import { Navbar } from 'shared/layouts/OldLandingLayout/ui/Navbar';
import { Content } from 'shared/layouts/OldLandingLayout/ui/Content';

import { Footer } from '../../widgets/Footer';

export const OldLandingLayout: React.FC = () => {
    const headingRef = useRef(null);
    const introRef = useRef(null);
    const createShopRef = useRef(null);
    const tariffRef = useRef(null);
    const collapsesRef = useRef(null);
    const faqRef = useRef(null);
    const contactsRef = useRef(null);

    const blockProps = {
        headingRef: headingRef,
        introRef: introRef,
        createShopRef: createShopRef,
        tariffRef: tariffRef,
        collapsesRef: collapsesRef,
        faqRef: faqRef,
        contactsRef: contactsRef,
    };

    return (
        <StyledLayout>
            <Navbar {...blockProps} />
            <Content {...blockProps} />
            <Footer contactsRef={contactsRef} />
        </StyledLayout>
    );
};

const StyledLayout = styled(Layout)`
    background: #ffffff;
`;
